import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@src/components/Avatar';
import { ButtonGreenPhone as Button } from '@src/components/Button';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const HeaderShowContact = (props) => {
	useStyles(css);
	const {
		avatarProps,
		children,
		labelBtn = t('Показать контакты'),
		onClickBtn,
		bgBtn,
	} = props;

	return (
		<div className={css.wrap}>
			{avatarProps && <Avatar size={48} {...avatarProps} />}

			{children}

			{onClickBtn && (
				<Button size="small" bg={bgBtn} label={labelBtn} onClick={onClickBtn} />
			)}
		</div>
	);
};

HeaderShowContact.propTypes = {
	avatarProps: PropTypes.shape(Avatar.type.propTypes),
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	labelBtn: PropTypes.string,
	onClickBtn: PropTypes.func,
	bgBtn: PropTypes.oneOf([undefined, 'black']),
};

HeaderShowContact.defaultProps = {
	avatarProps: undefined,
	children: undefined,
	labelBtn: undefined,
	onClickBtn: undefined,
	bgBtn: undefined,
};

export default HeaderShowContact;
